import * as React from 'react';
import ProspectHeader from '../common/ProspectHeader';
import PublicFooter from '../common/PublicFooter';

export interface Props {
    children: React.ReactNode;
    faqsSlug?: string;
}

const ProspectLayout = (props: Props) => {
    return (
        <div className="flex-root">
            <ProspectHeader faqsSlug={props.faqsSlug} />
            <main className="content container">{props.children}</main>
            <PublicFooter />
        </div>
    );
};

export default ProspectLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/ProspectLayout.tsx